import { render, staticRenderFns } from "./T1ResultsOffersPlaceholder.vue?vue&type=template&id=7ae03808&scoped=true&"
var script = {}
import style0 from "./T1ResultsOffersPlaceholder.vue?vue&type=style&index=0&id=7ae03808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae03808",
  null
  
)

export default component.exports